import React, { useState } from 'react';
import { Modal, Pressable, View } from 'react-native';
import { LANGUAGES, useAppStore } from '@restorant/core';
import { radius, useColors } from '../theme';
import { useT } from '../i18n';
import { Icon } from '../icons/Icon';
import { T } from './Text';

export function LanguageSwitcher() {
  const colors = useColors();
  const t = useT();
  const lang = useAppStore((s) => s.lang);
  const setLang = useAppStore((s) => s.setLang);
  const [open, setOpen] = useState(false);

  const current = LANGUAGES.find((l) => l.id === lang) ?? LANGUAGES[0];

  return (
    <>
      <Pressable
        onPress={() => setOpen(true)}
        testID="lang-switcher"
        accessibilityLabel={t('language')}
        style={({ hovered }: any) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: 7,
          paddingVertical: 8,
          paddingHorizontal: 12,
          borderRadius: radius.pill,
          borderWidth: 1,
          borderColor: hovered ? colors.gold : colors.line,
          backgroundColor: colors.surface,
        })}
      >
        <Icon name="languages" size={15} color={colors.textDim} />
        <T size={12.5} weight={700} color={colors.textDim}>
          {current.short}
        </T>
      </Pressable>

      <Modal visible={open} transparent animationType="fade" onRequestClose={() => setOpen(false)}>
        <Pressable
          onPress={() => setOpen(false)}
          style={{
            flex: 1,
            backgroundColor: colors.scrim,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
          }}
        >
          <Pressable
            onPress={() => {}}
            style={{
              width: '100%',
              maxWidth: 320,
              backgroundColor: colors.surface,
              borderWidth: 1,
              borderColor: colors.line,
              borderRadius: radius.lg,
              padding: 18,
              gap: 8,
            }}
          >
            <T size={15} weight={600} serif style={{ marginBottom: 4 }}>
              {t('language')}
            </T>
            {LANGUAGES.map((l) => {
              const active = l.id === lang;
              return (
                <Pressable
                  key={l.id}
                  onPress={() => {
                    setLang(l.id);
                    setOpen(false);
                  }}
                  style={({ hovered }: any) => ({
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingVertical: 12,
                    paddingHorizontal: 14,
                    borderRadius: radius.md,
                    borderWidth: 1,
                    borderColor: active ? colors.gold : colors.line,
                    backgroundColor: active || hovered ? colors.surface2 : 'transparent',
                  })}
                >
                  <T size={14} weight={active ? 700 : 500} color={active ? colors.gold : colors.text}>
                    {l.label}
                  </T>
                  {active ? <Icon name="check" size={16} color={colors.gold} /> : null}
                </Pressable>
              );
            })}
          </Pressable>
        </Pressable>
      </Modal>
    </>
  );
}
